<template>
<!-- :style="{width:(arrayList.length>1?'870px':'175px')}" -->
  <div class="overall">
    <!-- 步骤条盒子 -->
    <div class="time-select">
    </div>
    <div class="steps-box" v-show="arrayList.length>1">
      <!-- 步骤条 -->
      <p class="big-t" v-if="!isEnglish">{{topUnit}}</p>
      <p class="big-t" v-else>{{topUnit2}}</p>
      <div class="process">
        <div class="tiao">
          <div class="had-view" :style="{width:(bfb)}">
            <div class="yuan"></div>
          </div>
        </div>
      </div>
      <div class="zi">
        <!-- 最长20个刻度 -->
        <div class="kedu" v-for="i in newArr[nowPage]" :key="i.index">
          <div class="shu"></div>
          <span>{{bottomUnit(i.time)}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    timeResolutionUnit:{
      type:String
    },
    showSFM:{
      type:Boolean,
      default:false
    },
    arrayIndex:Number,
    arrayList:{
      type:Array,
      default:() =>[]
    },
    stepLength:{
      type:Number,
      default:18
    }
  },
  data() {
    return {
      PlayTimeRange:['2021-02-15','2022-01-25'],
      timeRnage:{
        startTime:'2021-02-15',
        endTime:'2022-01-25'
      },
      stepList: [
      ],
      nowPage:0,
      newArr:[
        []
      ],
      currentProcess:0,
      isEnglish: false
    };
  },
  watch:{
    arrayIndex(val){
      this.nowPage = parseInt(val/12)
      this.currentProcess = parseInt(val%12)
    },
    arrayList(){
      this.getTimeRange()
    }
  },
  mounted() {
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
  },
  computed:{
    topUnit(){
      let a
      if(this.arrayList.length>0){
        switch (this.timeResolutionUnit) {
          case 'y':
            return this.arrayList[this.arrayIndex].time.substr(0,4) + '年'
          case 'M':
            return this.arrayList[this.arrayIndex].time.substr(0,4) + '年'
          case 'd':
            return this.arrayList[this.arrayIndex].time.substr(0,7) + '月'
          case 'H':
            return this.arrayList[this.arrayIndex].time.substr(0,10) + '日'
          case 'm':
            return this.arrayList[this.arrayIndex].time.substr(0,13) + '时'
          default:
            if(this.arrayIndex===0){
              a = this.arrayList[this.arrayIndex]
            }else{
              a = this.arrayList[this.arrayIndex-1]
            }
            return a.time.substr(0,7) + '月'
        }
      }else{
        return ''
      }
    },
    topUnit2(){
      let a
      if(this.arrayList.length>0){
        switch (this.timeResolutionUnit) {
          case 'y':
            return this.arrayList[this.arrayIndex].time.substr(0,4) + 'Year'
          case 'M':
            return this.arrayList[this.arrayIndex].time.substr(0,4) + 'Year'
          case 'd':
            return this.arrayList[this.arrayIndex].time.substr(0,7) + 'Month'
          case 'H':
            return this.arrayList[this.arrayIndex].time.substr(0,10) + 'Day'
          case 'm':
            return this.arrayList[this.arrayIndex].time.substr(0,13) + 'Hour'
          default:
            if(this.arrayIndex===0){
              a = this.arrayList[this.arrayIndex]
            }else{
              a = this.arrayList[this.arrayIndex-1]
            }
            return a.time.substr(0,7) + 'Month'
        }
      }else{
        return ''
      }
    },
    bfb(){
      let result 
      try {
        result = Math.round(this.currentProcess / (this.newArr[this.nowPage].length-1) * 10000) / 100.00 + "%"
      } catch (error) {
        console.log('未查到');
      }
      return result
    }
  },
  methods: {
    bottomUnit(val){
      if(this.arrayList.length>0){
        switch (this.timeResolutionUnit) {
          case 'y':
            return val.substr(0,4)
          case 'M':
            return val.substr(5,2)
          case 'd':
            return val.substr(8,2)
          case 'H':
            return val.substr(11,2)
          case 'm':
            return val.substr(14,5)
          default:
            return val.substr(8,2)
        }
      }else{
        return ''
      }
    },
    getTimeRange(){
      let newList = JSON.parse(JSON.stringify(this.arrayList))
      console.log(this.arrayList);
      let arrLength = this.arrayList.length; // 数组长度
      let num = 12;  // 每页显示 10 条
      let index = 0;
      this.newArr = []
      for (let i = 0; i < arrLength; i++) {
          if (i % num === 0 && i !== 0) { // 可以被 10 整除
              this.newArr.push(newList.slice(index, i));
              index = i;
          }
          if ((i + 1) === arrLength) {
              this.newArr.push(newList.slice(index, (i + 1)));
          }
      }
    console.log(this.newArr);
    }
  },
  created(){
  },
};
</script>

<style lang="scss" scoped>
.overall{
  width: 631px;
  height: 54px;
  background-image: url("../assets/image/product-view-dialog/time-bg.png");
  display: flex;
  padding-right: 14px;
  background-size: 100% 100%;
}
.time-select{
  flex: 1;
  height: 100%;
}
.steps-box {
  width: 434px;
  height: 100%;
  .process{
    width: 100%;
  }
  .tiao{
    width: 100%;
    height: 2px;
    background: rgba(255, 255, 255, 1);
    position: relative;
    .had-view{
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      // width: 100%;
      // transition: width 0.05s linear; 
      background-color: rgba(0, 240, 255, 1);
      .yuan{
        position: absolute;
        right: 0;
        top: -4px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: rgba(0, 240, 255, 1);
      }
    }
  }
  .big-t{
    text-align: right;
    line-height: 24px;
    color: white;
  }
  .zi{
    width: 100%;
    display: flex;
    justify-content: space-between;
    .kedu{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: rgba(255, 255, 255, 1);
    }
    .shu{
      background: rgba(255, 255, 255, 1);
      width: 1px;
      height: 6px;
    }
  }
}
.time-r{
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 15px;
  padding:0 12px;
  .time-site{
    width: 80px;
    height: 20px;
    background-image: url("../assets/image/product-view-dialog/kuang.png");
    position: relative;
    span{
      font-size: 10px;
      color: white;
    }
    .time-picks{
      position: absolute;
      width: 100%;
      height: 20px;
      top: -5px;
      opacity: 0;
    }
  }
}
.tt1{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width:100%;
  height: 100%;
  margin: 0;
  opacity: 0;
}
</style>